export const CHAT_LIST_SIZE = 5;
export const GOOGLE_OAUTH_STATE = 'google_oauth_state';
